import { Aggregation, SeriesConfig } from 'genesis-suite/types/visualTypes'

export default function isRawSeries(series: SeriesConfig['series'][0]) {
    return series?.values.some(v => v.aggregation.toLowerCase() === Aggregation.NONE || v.aggregation.toLowerCase() === Aggregation.UNKNOWN)
}
